"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TaskInfo", {
    enumerable: true,
    get: function() {
        return TaskInfo;
    }
});
const _async_hooks = require("async_hooks");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class TaskInfo extends _async_hooks.AsyncResource {
    get id() {
        return this.options.id;
    }
    get weight() {
        return this.options.weight;
    }
    get abortSignal() {
        return this.options.abortSignal;
    }
    done(err, results) {
        const { cleanup, worker, resolve, reject } = this.options;
        if (cleanup) {
            this.runInAsyncScope(cleanup, null, worker);
        }
        if (err) {
            this.runInAsyncScope(reject, null, err, worker);
        } else {
            this.runInAsyncScope(resolve, null, results, worker);
        }
        this.emitDestroy();
    }
    constructor(options){
        super("WorkerPoolTaskInfo"), _define_property(this, "options", void 0), this.options = options;
        if (options.setup) {
            this.runInAsyncScope(options.setup, null, options.worker, options.worker.stdout, options.worker.stderr);
        }
    }
}
